module.exports = function ($scope) {
  $scope.submit = function () {
    $scope.closeThisDialog();
  };
};
